<!-- 查看导入记录 -->
<template>
  <div class="basicStyle">
    <div class="searchItem" style="margin-bottom: 20px">
      <span style="display: inline-block; margin-right: 10px">导入类型</span>
      <el-select
        v-model="queryInfo.type"
        size="small"
        class="w100Select"
        @change="queryTable('search')"
      >
        <!-- type类型：1开账户 2开会员 3开课程 4外呼导入用户 5导入学员 只显示235 -->
        <el-option label="全部" value=""></el-option>
        <!-- <el-option label="开账户" :value="1"></el-option> -->
        <el-option label="开会员" :value="2"></el-option>
        <el-option label="开课程" :value="3"></el-option>
        <!-- <el-option label="外呼导入用户" :value="4"></el-option> -->
        <el-option label="导入学员" :value="5"></el-option>
      </el-select>
    </div>
    <div class="table">
      <TableComponents
        :columns="columns"
        :tableData="tableList"
        :tableFunction="tableFunction"
      >
        <template slot="operation" slot-scope="{ row }">
          <span class="operationItem" @click="viewDetail(row, 1)">查看</span>
        </template>
      </TableComponents>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 30, 50, 80]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryInfo.total"
      >
      </el-pagination>
    </div>

    <!-- 新增编辑弹窗 -->
    <el-dialog
      :title="dialogType"
      :visible.sync="addFormShow"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="userInfoForm"
        label-width="100px"
      >
        <el-form-item label="手机号：" prop="mobile">
          <el-input
            v-model="userInfo.mobile"
            placeholder="请输入手机号"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="realname">
          <el-input
            v-model="userInfo.realname"
            placeholder="请输入真实姓名(2-6个汉字）"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证：" prop="id_card">
          <el-input
            v-model="userInfo.id_card"
            placeholder="请输入身份证"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="userInfo.remark"
            placeholder="请输入备注"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-radio-group v-model="userInfo.status" size="mini">
            <el-radio-button :label="1">启用</el-radio-button>
            <el-radio-button :label="0">禁用</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
import studentApi from "@/api/student.js";
import goodsApi from "@/api/goods.js";
import TableComponents from "@/components/TableComponents.vue";
export default {
  name: "ImportRecord",
  components: {
    TableComponents,
  },
  data() {
    var confirmPasswordVerify = (_, value, callback) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      } else if (value != this.codeInfo.new_password_confirmation) {
        return callback(new Error("两次密码输入需一致"));
      } else {
        callback();
      }
    };
    return {
      options: [],
      options1: [],
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        type: "",
      },
      columns: [
        //列数据
        { label: "导入类型", prop: "type_name" },
        { label: "成功数量", prop: "succ_total" },
        { label: "失败数量", prop: "fail_total" },
        { label: "总数量", prop: "total" },
        { label: "导入时间", prop: "created_at" },
        { label: "导入人", prop: "create_user" },
        { label: "操作", prop: "operation" },
      ],
      tableList: [],
      // 新增编辑表单数据
      addFormShow: false,
      userInfo: {
        mobile: "",
        realname: "",
        id_card: "",
        remark: "",
        status: 1,
        uid: "",
      },
      rules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
      },
      tableFunction: {
        checkData: 0, //是否允许勾选
        name: "choiceGoods",
      },

      // 选中的学员
      selectStudent: [],
    };
  },
  computed: {
    dialogType() {
      //  'this.userInfo.id',this.userInfo.uid);
      return this.userInfo.uid ? "编辑" : "新增";
    },
  },
  watch: {
    selectBuyGoodsShow: {
      handler(_newVal) {
        //  _newVal);
      },
    },
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          Object.keys(this.userInfo).forEach((key) => {
            if (typeof this.userInfo[key] == "string") {
              this.userInfo[key] = "";
            } else if (typeof this.userInfo[key] == "number") {
              this.userInfo[key] = 1;
            }
          });
          this.userInfo.uid = "";
        }
      },
    },
  },
  created() {
    if (this.$route.query.type) {
      this.queryInfo.type = Number(this.$route.query.type);
    }

    this.queryTable();
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobGoodList({ good_name: companyName });
          this.options = res.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobTagsList({ name: companyName });
          this.options1 = res.data.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      const res = await commonApi.studentsImportList(this.queryInfo);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;
        // this.tableList.forEach((item, index) => {
        //   if (item.type == 1) {
        //     item.typeName = "导入学员";
        //   } else if (item.type == 2) {
        //     item.typeName = "开会员";
        //   } else {
        //     item.typeName = "开课程";
        //   }
        // });
      } else {
        this.$message.error(res.message);
      }
    },
    // 打开弹窗
    viewDetail(row) {
      this.$router.push({
        path: "/importRecordDetail",
        query: {
          recordId: row._id,
        },
      });
    },
    // 添加｜｜修改数据
    addUser(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res;
          if (this.userInfo.uid) {
            res = await studentApi.studentsEdit(this.userInfo);
          } else {
            res = await studentApi.studentsAdd(this.userInfo);
          }
          if (res.code == 200) {
            this.$message.success(`${this.dialogType}成功`);
            this.queryTable();
            this.addFormShow = false;
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },

    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    resetQuery() {
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        status: -1, //状态 -1全部 1启用 0禁用
        is_active: -1, //是否激活 -1全部 1启用 0禁用
        keyword: "", //用户信息 支持账号真实姓名手机号
        start_time: "", //创建开始时间
        end_time: "", //创建结束时间
        tag_id: "", //标签id
        id_card: "", //身份证号
      };
      this.queryTable();
    },
    // 选择日期
    selectData(e) {
      //  e);
      this.queryInfo.start_time = e[0];
      this.queryInfo.end_time = e[1];
    },

    choiceGoods(e) {
      //  e);
      this.selectStudent = e;
    },
    async addCourse() {
      let _obj = this.selectStudent.map((item) => {
        return item.uid;
      });
      const res = await goodsApi.addCoursePower({
        tob_user_id: _obj.join(","),
        course_id: this.$route.query.courseId,
      });
      if (res.code == 200) {
        this.$message.success("添加学员成功");
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 20px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      margin-left: 50px;
    }
  }
  .addInfo {
    margin: 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
</style>
